import { Button, Typography, useColorScheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { type FC, useCallback, useMemo } from "react";

import { iconByColorMode } from "~/components/ColorModeButton/constant";

interface IColorModeButtonProps {
  text?: string;
}

export const ColorModeButton: FC<IColorModeButtonProps> = ({ text }) => {
  const { mode, systemMode, setMode } = useColorScheme();

  const resolvedMode = mode === "system" ? systemMode : mode;

  const Icon = useMemo(
    () => (resolvedMode ? iconByColorMode[resolvedMode] : ""),
    [resolvedMode]
  );

  const handleClick = useCallback(() => {
    setMode(resolvedMode === "light" ? "dark" : "light");
  }, [resolvedMode, setMode]);

  if (!resolvedMode || !Icon) {
    return null;
  }

  if (!text) {
    return (
      <IconButton size="large" onClick={handleClick}>
        <Icon />
      </IconButton>
    );
  }

  return (
    <Button
      size="large"
      onClick={handleClick}
      startIcon={<Icon color="disabled" />}
      fullWidth
      sx={{ justifyContent: "flex-start" }}
    >
      {text && (
        <Typography
          variant="caption"
          sx={{
            fontWeight: 500,
            textTransform: "none"
          }}>
          {text}
        </Typography>
      )}
    </Button>
  );
};
